import { render } from "./MiniCTASection.vue?vue&type=template&id=6684bfa6"
import script from "./MiniCTASection.vue?vue&type=script&lang=js"
export * from "./MiniCTASection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__